import React, { useState } from 'react';
import styles from './NewLogin.module.css';
import Background from '../../Asset/Background.png';
import logonew from '../../Asset/logonew.png';
import newtwo from '../../Asset/imgs2.jpg';
import dot from '../../Asset/Background.png';
import { Form, Button, Spinner } from "react-bootstrap";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { useNavigate, Link } from 'react-router-dom';
import Swal from "sweetalert2";
import axios from "axios";
import { BASE_URL } from "../../API/Api";

const NewLogin = () => {
   const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [email, setEmail] = useState('');
    const isButtonDisabled = !email || !password || loading;



  

    const handleKeyPress = (e) => {
        if (e.key === 'Enter'  && !isButtonDisabled) {
            handleLogin();
        }
    };
    const togglePassword = () => {
        setShowPassword(prev => !prev);
    };
    const handleEmail = (e) => {
        setEmail(e.target.value);
        setShowErrorMessage(false);
    };
    const handlePassword = (e) => {
        setPassword(e.target.value);
        setShowErrorMessage(false);
    };

   const handleLogin = async () => {
          setLoading(true);
          try {
              const response = await axios.post(`${BASE_URL}/login`,
                  {
                      email: email,
                      password: password
                  }
              );            
  
              const result = response.data?.data?.user?.name;
              const id = response.data?.data?.user?.id;
              const firstTime = response.data?.data?.user?.is_first_time;
              const emails = response.data?.data?.user?.email;
              const firstname = response.data?.data?.user?.first_name;
              const lastname = response.data?.data?.user?.last_name; 
              const middlename = response.data?.data?.user?.middle_name; 
              const phones = response.data?.data?.user?.phone; 
              const address = response.data?.data?.user?.address; 
              const tokens = response.data?.data?.token; 
              const pay = response.data?.data?.user?.reg_status;
  
              const bankName = response.data?.data?.bank?.bank_name; 
              const accountNumber = response.data?.data?.bank?.account_number; 
              const amount = response.data?.data?.payment?.amount; 
              const paymentType = response.data?.data?.payment?.payment_type; 
              const date = response.data?.data?.payment?.created_at; 
              const description = response.data?.data?.payment?.description;
              const add = response.data?.data?.payment?.address;
              const transaction = response.data?.data?.bank?.transaction_id;
              
              
              console.log(response, "userData");
              localStorage.setItem('status', pay);
              localStorage.setItem('BankName', bankName);
              localStorage.setItem('AccountNumber', accountNumber);
              localStorage.setItem('Amount', amount);
              localStorage.setItem('paymentType', paymentType);
              localStorage.setItem('Date', date);
              localStorage.setItem('Description', description);
              localStorage.setItem('UserAddress', add);
              localStorage.setItem('PayId', transaction);
  
              localStorage.setItem('userName', result);
              localStorage.setItem('token', tokens);
              localStorage.setItem('id', id);
              localStorage.setItem('firsttime', firstTime);
              localStorage.setItem('lastname', lastname);
              localStorage.setItem('firstname', firstname);
              localStorage.setItem('middlename', middlename);
              localStorage.setItem('Email', emails);
              localStorage.setItem('phone', phones);
              localStorage.setItem('address', address);
          
  
              if (pay === "0") {
                  navigate('/signup_invoice');
                } else if (firstTime === 0) {
                  navigate('/finish_onboarding_process');
                } else if (firstTime === 1 && pay == "1") {
                  navigate('/home');
                }
  
          } catch (error) {
              let errorMessage = 'An error occurred. Please try again.';
              if (error.response && error.response.data && error.response.data.message) {
                  if (typeof error.response.data.message === 'string') {
                      errorMessage = error.response.data.message;
                  } else if (Array.isArray(error.response.data.message)) {
                      errorMessage = error.response.data.message.join('; ');
                  } else if (typeof error.response.data.message === 'object') {
                      errorMessage = JSON.stringify(error.response.data.message);
                  }
                  setErrorMessage(JSON.stringify(error.response.data.message));
                  setShowErrorMessage(true);
                        Swal.fire({
                          icon: 'error',
                          title: 'Failed',
                          text: JSON.stringify(error.response.data.message),
                        });
              }
          } finally {
              setLoading(false);
          }
      }

  return (
    <div className={styles.container}>
      <div className={styles.general}>
        <div className={styles.left}>
          <div className={styles.formContainer}>
            <div className={styles.top}>
              <img src={logonew} alt="" className={styles.logo} />
              <h1 className={styles.title}>Welcome Back</h1>
              <p className={styles.subText}>Sign in to your OGSWC account.</p>
            </div>
          </div>

          {/* keep wrapper but let CSS control width on mobile */}
          <div className={`mx-auto ${styles.formOuter}`}>
            <Form className={`p-3 ${styles.formCard}`}>
              <Form.Group className="mb-3" controlId="email">
                <Form.Label
                  style={{
                    color: "#364153",
                    fontSize: 14,
                    fontWeight: 500,
                    marginBottom: 8,
                  }}
                >
                  Email
                </Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={handleEmail}
                  className={styles.inputContainer}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="password">
                <Form.Label
                  style={{
                    color: "#364153",
                    fontSize: 14,
                    fontWeight: 500,
                    marginBottom: 8,
                  }}
                >
                  Password
                </Form.Label>

                {/* absolute-eye wrapper for mobile/desktop */}
                <div className={styles.inputWrapper}>
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Enter Password"
                    value={password}
                    onChange={handlePassword}
                    className={styles.inputContainer}
                    required
                    onKeyPress={handleKeyPress}
                  />

                  <span
                    onClick={() => setShowPassword((s) => !s)}
                    className={styles.eyeIcon}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? <BsEyeSlash /> : <BsEye />}
                  </span>
                </div>
              </Form.Group>

              {/* Remember me + Forgot Password */}
              <div className={styles.rememberForgot}>
                <label className={styles.remember}>
                  <input
                    type="checkbox"
                    id="rememberMe"
                    name="rememberMe"
                    
                    className={styles.squareCheckbox}
                  />
                  Remember me
                </label>

                <span
                  className={styles.link}
                  
                >
                  Forgot password?
                </span>
              </div>

              <Button  disabled={isButtonDisabled} 
                        onClick={handleLogin} className={styles.button}>
                             {loading ? (
                                                            <>
                                                                <Spinner size='sm' />
                                                                <span style={{ marginLeft: '5px' }}>Signing in...</span>
                                                            </>
                                                        ) : (
                                                            "Sign In"
                                                        )}
                        </Button>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <p
                  className={styles.signupText}
                  style={{
                    marginTop: 26,
                    color: '#4A5565',
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  Don't have an account?{" "}
                  <span
                    style={{ color: '#009CC5', cursor: 'pointer' }}
                  >
                    <Link to="/signup" >
                    Sign up here
                    </Link>
                  </span>
                </p>
              </div>
            </Form>
          </div>
        </div>

        <div className={styles.right}>
          <div className={styles.background}>
            <img src={newtwo} alt="Background" className={styles.heroImage} />
            <div className={styles.infoSection}>
              <h2
                style={{
                  fontSize: 30,
                  color: '#fff',
                  fontWeight: 700,
                  marginBottom: 19,
                  marginTop: -20
                }}
              >
                Reliable Water Services
              </h2>
              <div style={{ width: 500 }}>
                <p
                  style={{
                    fontSize: 20,
                    color: '#DBEAFE',
                    fontWeight: 400,
                    marginBottom: 35,
                  }}
                >
                  Access your account to manage water services, view bills, and track consumption with ease.
                </p>

                <div className={styles.features}>
                  <div className={styles.feature}>
                    <img src={dot} alt="" />
                    <span>24/7 Account Access</span>
                  </div>
                  <div className={styles.feature}>
                    <img src={dot} alt="" />
                    <span>Real-time Bill Tracking</span>
                  </div>
                  <div className={styles.feature}>
                    <img src={dot} alt="" />
                    <span>Service Request Management</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default NewLogin;
